/*
 * Created Date: 16-08-2022, 10:29:57 am
 * Author: Peter
 * Email: phantrung696@gmail.com
 * -----
 * Last Modified:
 * Modified By:
 * -----
 * Copyright (c) 2022 PT CORP, Inc
 * -----
 * HISTORY:
 * Date      	By	Comments
 * ----------	---	----------------------------------------------------------
 */

// import { examReportPolicyService } from '@App/Pest/dashboard/services/examReportPolicyService'
import { ROUTER_AUTH, TRANSLATE_AUTH } from '@App/Auth/configs/const'
import authService from '@App/Auth/services/authService'
import PageLoader from '@Core/Components/Common/PageLoader'
import { errorMsg, successMsg } from '@Core/Helpers/Message'
import {
	clearSession,
	getAuthTokenSession,
	getDataSession,
	getLastRouter,
	removeDataSession,
	SESSION_STORAGE,
	setAuthDataSesstion,
	setAuthTokenSession,
	setLastRouter,
	setSystemSettingSession
} from '@Core/Helpers/Session'
import { hideLoadingPage, showLoadingPage } from '@Core/Helpers/System'
import { getQueryUrlObject, isLocalhost, redirectUrl } from '@Core/Helpers/Url'
import { useBoolean, useRequest, useUpdateEffect } from 'ahooks'
import PropTypes from 'prop-types'
import { createContext, useContext, useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next'
import { useNavigate } from 'react-router'
import { useLocation } from 'react-router-dom'
import { clearCacheUserInfo } from '@Core/Helpers/Cache'
import { APP_NAME } from '@Core/Components/const'
import { ROUTER_WORKSPACE_PLAN } from '@App/Studio/Modules/Workspace/Plan/configs/const'
import { useCoreAppContext } from '../CoreAppProvider'
import LoginDialog from './LoginDialog'
import CoreOnboardingProvider from '../CoreOnboardingProvider'
import { get } from 'lodash'
import { useSwitchLms } from '@App/Studio/Modules/Workspace/ClassRoom/useSwitchLms'
const CoreAuthContext = createContext({
	currentPlan: {},
	user: {},
	currentSchool: {},
	currentWorkspace: null,
	isAuthenticated: false
})
const CoreAuthActionsContext = createContext({
	loginWithPassword: () => {}
})

export const useCoreAuth = () => useContext(CoreAuthContext)

export const useCoreAuthActions = () => useContext(CoreAuthActionsContext)

const CoreAuthProvider = ({ children, app }) => {
	const { t } = useTranslation(TRANSLATE_AUTH)
	const navigate = useNavigate()
	const location = useLocation()
	const [currentPlan, setCurrentPlan] = useState({})
	const { systemConfig } = useCoreAppContext()

	// const [open, { setFalse, setTrue }] = useBoolean(true)

	// const [currentSchool, setCurrentSchool] = useState({})
	// console.log('============= currentSchool', currentSchool)
	// const [showBannerPopupAfterLogin, setShowBannerPopupAfterLogin] = useState(false)

	const [authData, setAuthData] = useState({
		user: null,
		isAuthenticated: false,
		isLoading: true
	})
	// console.log('============= authData', authData)

	const { data: userInfo, runAsync: getUserInfo } = useRequest(authService.getUserInfo, {
		manual: true,
		cacheKey: 'getUserInfo',
		cacheTime: 60 * 1000 * 5,
		staleTime: 60 * 1000 * 5,
		onSuccess: data => {
			// console.log('============= data', data)
			const user = {
				displayName: data?.info?.fullname,
				role: ['admin'],
				photoURL: '/assets/images/avatar/A11.jpg',
				...data
			}

			setAuthData({
				user,
				isLoading: false,
				isAuthenticated: true
			})
			setAuthDataSesstion(user)
			// const is_allow_lms = get(data, 'onboarding_data.is_allow_lms')
			// if (is_allow_lms && !isLocalhost()) {
			// 	redirectUrl('lms')
			// }
			// console.log('============= is_allow_lms', is_allow_lms)
		},
		onError: e => {
			setAuthData({
				user: undefined,
				isLoading: false,
				isAuthenticated: false
			})
			clearCacheUserInfo()
			localStorage.clear()
			navigate(ROUTER_AUTH.login)
		}
	})

	const getAuthUser = async () => {
		setSystemSettingSession(systemConfig)
		const { access_token } = getAuthTokenSession()
		// console.log('============= access_token', access_token)

		if (!access_token) {
			setAuthData({
				user: null,
				isLoading: false,
				isAuthenticated: false
			})
			clearCacheUserInfo()
			// navigate(ROUTER_AUTH.login)
			return
		}

		if (userInfo?.id) {
			const user = {
				displayName: userInfo?.info?.fullname,
				role: ['admin'],
				photoURL: '/assets/images/avatar/A11.jpg',
				...userInfo
			}
			const query = getQueryUrlObject()
			if (query?.plan_slug) {
				navigate(ROUTER_WORKSPACE_PLAN.list_plan, {
					state: query
				})
			}
			setAuthData({
				user,
				isLoading: false,
				isAuthenticated: true
			})
			setAuthDataSesstion(user)
			return
		}

		// await getCurrentPlan()
		// await authService.studioCsrf()
		await getUserInfo()
	}

	useUpdateEffect(() => {
		if (authData?.user?.status && authData?.user?.status !== 'VERIFIED') {
			// navigate(ROUTER_AUTH.verify_email)
		}
	}, [JSON.stringify(authData)])

	const handleChangeSite = async (accessToken, tokenType) => {
		setAuthTokenSession({ access_token: accessToken, token_type: tokenType })
		await authService.csrf()
		await getAuthUser()
		// router.push(router?.pathname ?? '/')
		// setShowBannerPopupAfterLogin(true)
	}

	useEffect(() => {
		const query = getQueryUrlObject()
		getAuthUser()
	}, [])

	useUpdateEffect(() => {
		const backUrl = getDataSession(SESSION_STORAGE, 'backUrl')
		if (backUrl) {
			removeDataSession(SESSION_STORAGE, 'backUrl')
			redirectUrl(backUrl)
		} else if (authData.isAuthenticated && app === APP_NAME.auth) {
			navigate(getLastRouter())
		}
	}, [authData.isAuthenticated])

	const loginWithPassword = async (data, oldUrl) => {
		try {
			const res = await authService.loginWithPassword(data)
			setAuthTokenSession(res)
			await getAuthUser()
			successMsg(t('Login success'))
			// if(app !== APP_NAME.auth)
			// const query = getQueryUrlObject()
			// if (query?.backUrl) {
			// 	redirectUrl(query?.backUrl)
			// 	return
			// }
			navigate(getLastRouter())
		} catch (e) {
			errorMsg(e, t('Login failed'))
		}
	}

	const adminLoginAccountUser = async data => {
		showLoadingPage()
		try {
			const res = await authService.adminLoginAccountUser(data)
			setAuthTokenSession(res)
			await getAuthUser()
			// await getUserPoint()
			// await getExamReportCount()
			// router.replace('/', undefined, { shallow: true })
			successMsg(t('message.login_success'))
		} catch (error) {
			errorMsg(t('message.login_failed'))
		}
		hideLoadingPage()
	}

	const logout = async (callback = () => {}) => {
		showLoadingPage()
		await authService.logout()
		clearSession()
		setAuthData({
			user: null,
			isLoading: false,
			isAuthenticated: false
		})
		if (app === 'workspace') {
			navigate(ROUTER_AUTH.login)
		}
		clearCacheUserInfo()
		// setUserPoint(null)
		// setCurrentPlan({})
		hideLoadingPage()
		callback()
		// if (lastUrl) {
		// 	setLastRouter(lastUrl)
		// }
	}

	const responseFacebook = async response => {
		showLoadingPage()
		try {
			const res = await authService.loginBySocial('facebook', {
				...response,
				social_token: response?.accessToken
			})
			setAuthTokenSession(res)
			await getAuthUser()
			// await getUserPoint()
			// await getExamReportCount()
			successMsg(t('message.login_success'))
		} catch (error) {
			console.log('============= error', error)
			errorMsg(t('message.login_failed'))
		}
		hideLoadingPage()
	}

	const responseGoogle = async response => {
		// console.log('============= response', response)
		showLoadingPage()
		try {
			const res = await authService.loginBySocial('google', {
				...response,
				social_token: response?.access_token,
				id_token: response?.credential
			})
			console.log('============= res', res)
			setAuthTokenSession(res)
			await getAuthUser()
			successMsg(t('message.login_success'))
		} catch (error) {
			console.log('============= error', error)
			errorMsg(t('message.login_failed'))
		}
		hideLoadingPage()
	}

	return (
		<CoreAuthContext.Provider
			value={{
				// currentSchool,
				// currentPlan,
				// getCurrentPlan,
				...authData,
				setAuthData,
				// currentWorkspace,
				// userPoint,
				currentPlan,
				// setUserPoint,
				// reportCount,
				// setReportCount,
				// setCurrentPlan,
				// showBannerPopupAfterLogin,
				// setShowBannerPopupAfterLogin,
				// isActiveAffiliateChanel,
				tAuth: t
			}}
		>
			<CoreAuthActionsContext.Provider
				value={{
					// signUpUser,
					loginWithPassword,
					logout,
					responseFacebook,
					getAuthUser,
					getUserInfo,
					// getUserPoint,
					// getExamReportCount,
					adminLoginAccountUser,
					responseGoogle
					// switchWorkspace,
					// loadingSwitchWorkspace
					// responseFacebook
				}}
			>
				{authData.isLoading ? <PageLoader /> : <CoreOnboardingProvider>{children}</CoreOnboardingProvider>}
				{/* <LoginDialog open={open} handleClose={setFalse} /> */}
			</CoreAuthActionsContext.Provider>
		</CoreAuthContext.Provider>
	)
}
export default CoreAuthProvider

CoreAuthProvider.propTypes = {
	children: PropTypes.node.isRequired
}
